import { render } from "./NewsCreate.vue?vue&type=template&id=240bf3b6"
import script from "./NewsCreate.vue?vue&type=script&lang=js"
export * from "./NewsCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__